import { render } from "./slide8.vue?vue&type=template&id=7d548712"
import script from "./slide8.vue?vue&type=script&lang=js"
export * from "./slide8.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__